import { createFileRoute } from "@tanstack/react-router";
import { AIAgentsPage } from "~/pages/AIAgentsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/ai-agents")({
  component: RouteComponent,
});

function RouteComponent() {
  return <AIAgentsPage />;
}